import { createFileRoute } from '@tanstack/react-router'
import { AuditPage } from '@/components/audit/page'

export const Route = createFileRoute('/_app/org/audit/')({
  component: () => <AuditPage scope="org" />,
})
